import axios from 'axios';
import React from 'react';
import { Pie, defaults } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm } from 'redux-form';
import CustomerType from '../../component/CustomerType';
import UserProductStatus from '../../component/UserProductStatus';
var moment = require('moment');
var _ = require('lodash');
var numeral = require('numeral');

// Set Responsive for line chart
defaults.global.maintainAspectRatio = false;

function redirect_url() {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    return "http://localhost:3001";
  } else {
    return "https://id.tadu.cloud";
  }
}


function AgencyCustomerList(data) {
  const agency_customer_rows = _.map(data, (i, index) => {
    return (
      <li key={`_cusomterData_${index}`} className="media">
        <a href="#" className="media-link">
          <div className="media-body">
              <span style={{color: !i.is_active && "red"}} className="text-semibold">{index + 1}. {i.email} </span>
              <br/>
            <small className="text-muted">{i.full_name}</small>
          </div>
          <div className="media-right media-middle">
            <span className="bagde bg-success"></span>
          </div>
        </a>
      </li>
    );
  })
  return agency_customer_rows;
}

function ProductName(userProduct) {
  const types_with_domain_title = ["COM_DOMAIN", "VN_DOMAIN", "TADU_PHONE", "SSL","EMAIL" , "LINUX_HOSTING", "WINDOW_HOSTING"];
  return (
    <React.Fragment>
      {userProduct.name && userProduct.product.product_type == "VPS" && userProduct.name}
      {!userProduct.name && userProduct.product.product_type == "VPS" && "Chưa đặt tên"}
      {types_with_domain_title.includes(userProduct.product.product_type) && userProduct.domain}
      <span className="display-block text-muted">{userProduct.ip_address}</span>
      <span className="display-block text-muted">{userProduct.product.name}</span>
    </React.Fragment>
  )
}

function ProductTypeLabelCase(productType) {
    switch(productType.toString()) {
      case "WINDOW_HOSTING" : {
        return "Window Hosting"
      }
      case "LINUX_HOSTING" : {
        return "Linux Hosting"
      }
      case "SSL" : {
        return "SSL"
      }
      case "VN_DOMAIN" : {
        return "Tên miền VN"
      }
      case "COM_DOMAIN" : {
        return "Tên miền Quốc Tế"
      }
      case "VPS" : {
        return "Cloud Server"
      }
      case "EMAIL" : {
        return "Email Server"
      }
      case "TADU_PHONE" : {
        return "Tổng Đài Ảo"
      }
      case "TADU_INVOICE" : {
        return "Hoá Đơn Điện Tử"
      }
      case "CLOUD_BACKUP" : {
        return "Cloud Backup"
      }
    }
}

function ServiceRenewList(renew_data) {
  const renew_service_rows = _.map(renew_data, (i, index) =>{
    return (
      <tr key={`_serviceRenew_${index}`}>
        <td>{i.user.email}</td>
        <td>{ProductName(i)}</td>
        <td>{UserProductStatus(i)}</td>
        <td>
          {moment(i.registered).format("DD-MM-YYYY")}
          <br/>
          <small className="text-muted">{moment(i.expired).format("DD-MM-YYYY")}</small>
        </td>
        {/* <td>

        </td> */}
      </tr>
    )
  })
  return renew_service_rows;
}

function LineChartData(static_data) {
  const data = {
    labels: _.map(static_data, (i) => ProductTypeLabelCase(i.product_type)),
    datasets: [
      {
        label: 'TỔNG',
        type:'pie',
        lineTension: 0.1,
        fill: false,
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderCapStyle: 'butt',
        borderDash: [],
        backgroundColor: [
          'orange',
          'lightgreen',
          'brown',
          'lightblue',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)'
        ],
        data: _.map(static_data, (i) => i.static),
      }
    ],
    options:{
      animation: {
        duration: 0
      }
    }
  };

  return data;
}


class CustomerDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      general_service_static: [],
      service_need_renew: [],
      service_renew_list: [],
      is_show_password_confirm_modal: false
    }
  }

  service_renew_list() {
    const { customer_id } = this.props.match.params;
    const self = this;
    axios({
      method: 'get',
      url: window.api_url + '/admin/api/customer/service/renew/' + customer_id,
      withCredentials: true
    }).then(function (response) {
      self.setState({
        ...self.state,
        service_renew_list: response.data.data
      })
    });
  }
  
  service_static() {
    const { customer_id } = this.props.match.params;
    const self = this;
    axios({
      method: 'get',
      url: window.api_url + '/admin/api/customer/service/static/' + customer_id,
      withCredentials: true
    }).then(function (response) {
      self.setState({
        ...self.state,
        general_service_static: response.data.data
      })
    });
  }

  onLoginBySale = (customer_id) => {
    return axios({
      method: 'post',
      url: window.api_url + '/admin/api/customer/login-by-sale',
      data: {
        customer_id: customer_id
      },
      withCredentials: true
    }).then(function (response) {
      if (!response.data.isError) {
        window.open(redirect_url());
      }
    });
  }

  onHideModal = () => {
    this.setState({
      is_show_password_confirm_modal: false
    })
  }
  
  componentDidMount() {
    const { customer_id } = this.props.match.params;
    const { loadCustomerAsync } = this.props;
    this.service_static();
    this.service_renew_list();
    loadCustomerAsync(customer_id);
  }

  render() {
    const { customer_data, agency_customer_list } = this.props;
    const { general_service_static, service_renew_list, is_show_password_confirm_modal } = this.state;
    // Tổng tất cả các dịch vụ.
    let sum_static = 0;
    const static_rows = _.map(general_service_static, function(i, index) {
      sum_static += i.static;
      return (
        <React.Fragment key={`customerServiceData_${index}`}>
          <i className="icon-cog6"></i> {i.product_type} <span style={{float: 'right'}} className="badge bg-teal pull-right">{i.static}</span>
          <br/>
        </React.Fragment>
      )
    })
    return(
      customer_data && <React.Fragment>
        <div className="page-header">
          <div className="page-header-content header-elements-md-inline">
            <div className="page-title d-flex">
              <h4>
                <i className="icon-paragraph-justify2 mr-2"></i>
                <span className="text-semibold">Thông Tin Chi Tiết Khách Hàng</span>
              </h4>
            </div>
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-lg-3">
            <div className="card card-body thumbnail">
              <div className="thumb thumb-rounded thumb-slide">
                <div className="caption">
                  <span>
                  </span>
                </div>
              </div>
              <div className="caption text-center">
                <h6 className="text-semibold no-margin">{customer_data.email}<small className="display-block">{customer_data.full_name}</small></h6>
                <br/>
                <p><span className="icon-phone2"></span> {customer_data.phone}</p>
                {customer_data.address && <p><i className="icon-home"></i> {customer_data.address}</p>}
                <p style={{color: customer_data.role == "CUSTOMER" && customer_data.agency && customer_data.agency.has_custom_brand && "red"}}>{CustomerType(customer_data)}</p>
                <br/>
                <button disabled={customer_data.role == "CUSTOMER" && customer_data.agency && customer_data.agency.has_custom_brand && true} onClick={()=> this.onLoginBySale(customer_data.id)} className="btn btn-warning">Đăng nhập <i className="icon-arrow-right15"></i></button>
              </div>
            </div>
            <div className="card card-body">
              <h6 className="panel-title">Dịch vụ</h6>
              <div style={{fontWeight: 'bold'}}>
                {static_rows}
                <i className="icon-cog6"></i> TẤT CẢ <span style={{float: 'right'}} className="badge bg-teal pull-right">{sum_static}</span>
              </div>
            </div>
            {/* Chỉ sử dụng cho đại lý xem danh sách khách hàng */}
            {customer_data.role == "AGENCY" && <div className="card card-body">
              <h6 className="panel-title">
                Khách hàng <span className="badge badge-primary">{agency_customer_list.length}</span>
                {/* <a style={{float:'right'}} href="#">xem tất cả <i className=" icon-arrow-right5"></i></a> */}
              </h6>
              <ul style={{height: "300px", overflow: "auto"}} className="media-list media-list-linked pb-5">
                {AgencyCustomerList(agency_customer_list)}
              </ul>
            </div>}
          </div>
          <div className="col-lg-9">
            <div className="card card-body">
              <p>Dịch Vụ</p>
              <article style={{height: "60vh"}} className="canvas-container">
                <Pie data={LineChartData(general_service_static)} height={150} width={500} />
              </article>
            </div>
            <div className="card card-body">
              <p>Dịch Vụ Cần Gia Hạn</p>
              <table className="table table-togglable table-hover default footable-loaded footable">
                <thead>
                  <tr key="_customerServiceTable"> 
                    <th>
                      Khách Hàng
                      <br/>
                      <small className="text-muted">
                        Đại Lý
                      </small>
                    </th>
                    <th>
                      Sản Phẩm
                    </th>
                    <th>
                      Trạng Thái
                    </th>
                    <th>
                      Khởi Tạo
                      <br/>
                      <small className="text-muted">Hết Hạn</small>
                    </th>
                    {/* <th style={{textAlign: 'right'}}>
                      Phí Khởi Tạo
                    </th> */}
                  </tr>
                </thead>
                <tbody>
                  {service_renew_list.length > 0 && ServiceRenewList(service_renew_list)}
                </tbody>
                {/* <tfoot className="card-footer">
                  <td style={{textAlign: 'right'}} colspan="5">
                    <strong>Tổng Tiền: </strong>
                  </td>
                </tfoot> */}
              </table>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const mapState = state => ({
  customer_data: state.customerData.data,
  agency_customer_list: state.customerData.agency_customer_list
});

const mapDispatch = (dispatch) => ({
  loadCustomerAsync: (customer_id) => dispatch.customerData.loadCustomerAsync(customer_id)
});


const CustomerDetailWrapper = reduxForm({
  form: 'CustomerDetail',
  destroyOnUnmount: true,
  enableReinitialize: true,
})(CustomerDetail);

export default connect(mapState, mapDispatch)(withRouter(CustomerDetailWrapper));
